<ng-container *ngIf="form">
  <form
    [formGroup]="form"
  >
    <div class="container-fluid">
      <div class="row form-grid">
        <ng-container *ngFor="let item of formConfig">
          <ng-container [ngSwitch]="item.type">

            <div class="p-field flexible form-grid__field" [style.width]="fieldWidth(item)">

              <div class="p-field__title"
                   *ngIf="!isSwitch(item.type)"
              >
                <label class="text--md" for="{{item.name}}">{{ item.label }}</label>
                <span class="error-text" *ngIf="isRequired(item.name)">*</span>

                <ng-container *ngIf="!isMask(item.type)" >
                  <app-icon-feather
                    *ngIf="isValidIconVisible(item)"
                    icon="check-circle"
                  ></app-icon-feather>

                  <app-icon-feather
                    *ngIf="isErrorIconVisible(item.name)"
                    icon="x-circle"
                  ></app-icon-feather>
                </ng-container>

                <!--
                  Scan / Voice input / Manual input used to sit here. None of
                  them carried a click handler anywhere in this component, so
                  they were three dead controls on every field of every form —
                  and the tooltips promised input methods that do not exist.
                  The help icon stays: it renders only where a field actually
                  supplies pTooltip text.
                -->
                <div class="ml-auto" *ngIf="item.pTooltip">
                  <app-icon
                    icon="i-26"
                    fill="#528BB0"
                    [pTooltip]="item.pTooltip"
                  ></app-icon>
                </div>
              </div>

              <ng-container *ngSwitchCase="'string'" >
                <input
                  pInputText
                  [formControlName]="item.name"
                  [attr.placeholder]="item.placeholder"
                  id="{{item.name}}"
                  type="text"
                  (input)="onInputChange.next([$event, item])"
                />
              </ng-container>

              <ng-container *ngSwitchCase="'textarea'" >
              <textarea
                class="w-100"
                [formControlName]="item.name"
                [attr.placeholder]="item.placeholder"
                id="{{item.name}}"
                rows="5"
                (input)="onInputChange.next([$event, item])"
              ></textarea>
              </ng-container>

              <ng-container *ngSwitchCase="'number'" >
                <p-inputNumber
                  [formControlName]="item.name"
                  [placeholder]="item.placeholder"
                  inputId="{{item.name}}"
                  (onInput)="onInputChange.next([$event, item])"
                >
                </p-inputNumber>
              </ng-container>

              <ng-container *ngSwitchCase="'dropdown'">
                <p-dropdown
                  [options]="item.list"
                  [formControlName]="item.name"
                  [placeholder]="item.placeholder"
                  inputId="{{item.name}}"
                  (onChange)="onInputChange.next([$event, item])"
                ></p-dropdown>
              </ng-container>

              <ng-container *ngSwitchCase="'calendar'">
                <p-calendar
                  inputId="{{item.name}}"
                  dateFormat="mm-dd-yy"
                  [monthNavigator]="true"
                  [yearNavigator]="true"
                  [yearRange]="yearRange"
                  [maxDate]="dateNow"
                  [formControlName]="item.name"
                  [placeholder]="item.placeholder"
                  [readonlyInput]="true"
                  [showIcon]="false"
                  (onSelect)="onInputChange.next([$event, item])"
                ></p-calendar>
              </ng-container>

              <ng-container *ngSwitchCase="'mask'">
                <p-inputMask
                  [formControlName]="item.name"
                  [placeholder]="item.placeholder"
                  [autoClear]="false"
                  mask="{{item.mask}}"
                  inputId="{{item.name}}"
                  slotChar="_"
                  [unmask]="true"
                  [ariaRequired]="true"
                  (onComplete)="onInputChange.next([$event, item])"
                ></p-inputMask>
              </ng-container>

              <ng-container *ngSwitchCase="'radio'">
                <div class="d-flex flex-wrap align-items-center mx-n3">
                  <div class="p-field-radiobutton d-flex align-items-center col-md-{{ item.col || 12 }}"
                       *ngFor="let radio of item.list"
                  >
                    <p-radioButton
                      name="{{item.name}}"
                      [value]="radio.value"
                      inputId="{{item.name + radio.value}}"
                      [formControlName]="item.name"
                      (onClick)="onInputChange.next([$event, item])"
                    ></p-radioButton>
                    <label class="text--md" for="{{item.name + radio.value}}">{{radio.label}}</label>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'checkbox'">
                <div class="d-flex flex-wrap align-items-center mx-n3">
                  <div
                    *ngFor="let radio of item.list"
                    class="p-field-checkbox d-flex align-items-center col-md-{{ item.col || 12 }}">
                    <p-checkbox
                      inputId="{{item.name + radio.value}}"
                      name="{{item.name}}"
                      [value]="radio.value"
                      [formControl]="form.controls[item.name]"
                      (onChange)="onInputChange.next([$event, item])"
                    ></p-checkbox >
                    <label class="text--md" for="{{item.name + radio.value}}">{{radio.label}}</label>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'switch'">
                <div class="d-flex align-items-center">
                  <p-inputSwitch
                    class="d-inline-flex"
                    inputId="{{ item.name }}"
                    [formControlName]="item.name"
                    (onChange)="onInputChange.next([$event, item])"
                    [attr.name]="item.name"
                  >
                  </p-inputSwitch>

                  <label
                    class="text--md ml-3"
                    *ngIf="isSwitch(item.type)"
                    for="{{item.name}}"
                  >
                    {{item.label}}
                  </label>
                </div>
              </ng-container>

              <div class="position-relative">
                <small class="p-error"
                       *ngIf="form.controls[item.name]?.dirty && form.controls[item.name]?.invalid"
                >
                  {{ getErrorMessage(item.label, form.controls[item.name]) }}
                </small>
              </div>

            </div>

          </ng-container>
        </ng-container>

      </div>
    </div>
  </form>
</ng-container>
